import { Injectable } from '@angular/core';
import moment from 'jalali-moment';
import { PersianDayEnum } from '../interfaces/days-enum';

@Injectable({
  providedIn: 'root'
})

export class DateService {

  constructor() { }

  getTodayPersianDate(): string {
    return moment().locale('fa').format('jYYYY/jMM/jDD');
  }

  getTodayGregorianDateTime(): string {
    return moment().locale('en').format('YYYY-MM-DD HH:mm:ss');
  }

  getTodayGregorianDate(): string {
    return moment().locale('en').format('YYYY-MM-DD');
  }

  getPersianDatesWithDetails(): { 
    day: string; 
    date: string; 
    dayEnum: number; 
    gregorianDateTime: string; 
  }[] {
    const today = moment();
    const endOfNextMonth = moment().add(1, 'month').endOf('month');

    const dates: { 
      day: string; 
      date: string; 
      dayEnum: number; 
      gregorianDateTime: string; 
    }[] = [];
    let current = today.clone();

    while (current.isBefore(endOfNextMonth) || current.isSame(endOfNextMonth, 'day')) {
      const dayName = current.format('dddd'); // Persian day name
      dates.push({
        day: dayName,
        date: current.format('jYYYY/jMM/jDD'), // Jalali date
        dayEnum: PersianDayEnum[dayName as keyof typeof PersianDayEnum], // Map day name to enum
        gregorianDateTime: current.clone().locale('en').format('YYYY-MM-DD HH:mm:ss'), // Gregorian date-time
      });
      current = current.add(1, 'day'); // Increment by one day
    }

    return dates;
  }

  getPersianDatesWithDayEnumUntilNextMonth(): { day: string; date: string; dayEnum: number }[] {
    const today = moment();
    const endOfNextMonth = moment().add(1, 'month').endOf('month');

    const dates: { day: string; date: string; dayEnum: number }[] = [];
    let current = today.clone();

    while (current.isBefore(endOfNextMonth) || current.isSame(endOfNextMonth, 'day')) {
      const dayName = current.format('dddd'); // Persian day name
      dates.push({
        day: dayName,
        date: current.format('jYYYY/jMM/jDD'), // Jalali date
        dayEnum: PersianDayEnum[dayName as keyof typeof PersianDayEnum], // Map day name to enum
      });
      current = current.add(1, 'day'); // Increment by one day
    }

    return dates;
  }

  getPersianDatesWithDayUntilNextMonth(): { day: string; date: string }[] {
    const today = moment();
    const endOfNextMonth = moment().add(1, 'month').endOf('month');

    const dates: { day: string; date: string }[] = [];
    let current = today.clone();

    while (current.isBefore(endOfNextMonth) || current.isSame(endOfNextMonth, 'day')) {
      dates.push({
        day: current.format('dddd'), // Day of the week in Persian
        date: current.format('jYYYY/jMM/jDD'), // Jalali date
      });
      current = current.add(1, 'day'); // Increment by one day
    }

    return dates;
  }

  getPersianDatesUntilNextMonth(): string[] {
    const today = moment();
    const endOfNextMonth = moment().add(1, 'month').endOf('month');

    const dates: string[] = [];
    let current = today.clone();

    while (current.isBefore(endOfNextMonth) || current.isSame(endOfNextMonth, 'day')) {
      dates.push(current.format('jYYYY/jMM/jDD'));
      current = current.add(1, 'day'); // Increment by one day
    }

    return dates;
  }
}
